import { CHARACTER_WHITESPACE, EMPTY_STRING } from '../../constants/common'
import { RENTAL_PORTAL_APPLICANT_SOURCE_LABEL_KEY } from '../../constants/rentalPortal'
import { PROFILE_ROUTE_NAMES } from '../../constants/route'

import {
  APPLICANT_CREDIT_CHECK_BAND_LABEL_KEY,
  APPLICANT_CREDIT_CHECK_BAND_TEXT_COLOR,
  APPLICANT_MASKED_TEXT_COLOR,
  APPLICANT_PROFILE_BLOCK,
  APPLICANT_PROFILE_BLOCK_PARAM,
} from './RentalPortalApplicant.constants'

function toApplicantIdentity(applicant) {
  const isMasked = getIsApplicantFieldMasked(applicant.first_name)

  return {
    masked: isMasked,
    value: isMasked
      ? null
      : [applicant.first_name.value, applicant.last_name?.value]
          .filter(Boolean)
          .join(CHARACTER_WHITESPACE) || null,
  }
}

export function getIsApplicantFieldMasked(field) {
  return field?.masked !== false
}

export function toApplicantDetail({ data }) {
  return { data: toApplicantTableItem(data) }
}

export function toApplicantTableItem(applicant) {
  return {
    ...applicant,
    identity: toApplicantIdentity(applicant),
    source:
      RENTAL_PORTAL_APPLICANT_SOURCE_LABEL_KEY[applicant.source] ??
      applicant.source,
  }
}

export function getApplicantFieldValue(field) {
  return getIsApplicantFieldMasked(field) ? null : (field?.value ?? null)
}

export function getApplicantMaskedFieldText({ emptyKey, field, maskedKey, t }) {
  if (getIsApplicantFieldMasked(field)) {
    return t(maskedKey)
  }

  return field.value || (emptyKey ? t(emptyKey) : EMPTY_STRING)
}

export function getApplicantCreditCheckBandProps({ field, t }) {
  const band = getApplicantFieldValue(field)

  return {
    text: t(
      APPLICANT_CREDIT_CHECK_BAND_LABEL_KEY[band] ??
        'RentalPortal.ApplicantProfileMaskedValueKey'
    ),
    textColor:
      APPLICANT_CREDIT_CHECK_BAND_TEXT_COLOR[band] ??
      APPLICANT_MASKED_TEXT_COLOR,
  }
}

export function getApplicantFormOptionalLabel({ label, t }) {
  return `${t('RentalPortal.FormOptionalFieldLabelKey', { label })}:`
}

export function toApplicantHouseholdSizeSelectItems({ sizes, t }) {
  return sizes.map(size => ({
    label: t('RentalPortal.ApplicantFormHouseholdSizeOptionKey', {
      count: size,
    }),
    value: size,
  }))
}

export function getApplicantProfileLink(id) {
  return PROFILE_ROUTE_NAMES.rentalPortalApplicantProfile({ id })
}

export function getApplicantProfileDecisionLink(id) {
  return `${getApplicantProfileLink(id)}?${APPLICANT_PROFILE_BLOCK_PARAM}=${APPLICANT_PROFILE_BLOCK.decision}`
}

export function toApplicantDocumentVerdictData({ rejectedReason, status }) {
  return {
    status,
    ...(rejectedReason ? { rejected_reason: rejectedReason } : null),
  }
}

export function toApplicantDocumentLinkData({ documentKey, fileId }) {
  return {
    file_id: fileId,
    ...(documentKey ? { document_key: documentKey } : null),
  }
}
